interface DetailItemProps {
  label: string;
  value: any;
}

export default function DetailItem({ label, value }: DetailItemProps) {
  const displayValue = value || "N/A";
  const titleValue =
    typeof displayValue === "string" || typeof displayValue === "number"
      ? String(displayValue)
      : undefined;
  return (
    <div className="flex flex-col gap-0 min-w-0">
      <p className="text-[12px] text-[var(--color-black-6)] tracking-[-0.24px] truncate">
        {label}
      </p>
      {/* Wraps instead of truncating: on a phone the drawer's cells are
          ~150px, and a campaign / ad / date cut to "Video 3 Kerala …" can't
          be read anywhere else on the screen. */}
      <p
        className="text-[14px] font-medium text-[var(--color-black-10)] tracking-[-0.28px] break-words"
        title={titleValue}
      >
        {displayValue}
      </p>
    </div>
  );
}
